import {generateUUID4} from '../data/random'

export interface ITimer {
  isAlive(): boolean
  start(): void
  stop(): void
  restart(): void
  subscribe(callbackFn: () => void): () => void
}

export default class Timer implements ITimer {
  private refreshInterval: number = 300000
  private timerRef: number | undefined
  private subscribers: {}
  private isStoped: boolean = true
  constructor() {
    this.subscribers = {}
    this.unsubscribe = this.unsubscribe.bind(this)
  }
  public isAlive() {
    return this.timerRef > 0 && this.timerRef !== undefined
  }
  public start() {
    this.stop()
    this.timerRef = window.setTimeout(this.handler.bind(this), this.refreshInterval)
    this.isStoped = false
  }
  public setRefreshInterval(timeInMilliseconds: number) {
    this.refreshInterval = timeInMilliseconds
  }
  public stop() {
    if (this.isAlive()) {
      clearTimeout(this.timerRef)
      this.timerRef = undefined
    }
    this.isStoped = true
  }
  public restart() {
    this.stop()
    this.start()
  }
  public subscribe(callbackFn) {
    const callbackFnUuid = generateUUID4()
    this.subscribers[callbackFnUuid] = callbackFn
    if (Object.keys(this.subscribers).length > 0) {
      this.restart()
    }
    return () => {
      return this.unsubscribe(callbackFnUuid)
    }
  }

  private unsubscribe(callbackFnUuid) {
    if (this.subscribers[callbackFnUuid] === undefined) {
      return
    }
    delete this.subscribers[callbackFnUuid]
    if (Object.keys(this.subscribers).length <= 0) {
      this.stop()
    }
  }
  private handler() {
    const callbackKeys = Object.keys(this.subscribers)
    callbackKeys.forEach((callBackUuid) => {
      this.subscribers[callBackUuid]()
    })

    // if no subscribers then stop loop
    if (callbackKeys.length <= 0) {
      this.stop()
    }
    // if it is not stopped then continue interval
    if (!this.isStoped) {
      this.start()
    }
  }
}

export const timer = new Timer()
